import { type LucideProps } from 'lucide-react'

/**
 * Hierarchy Level 6 Icon
 *
 * Six chevrons arranged in a dice-face pattern (2 columns x 3 rows).
 * Represents the sixth organizational level (Working group).
 *
 * Pattern: Like the 6 on a die
 *   ^   ^
 *   ^   ^
 *   ^   ^
 */
export function HierarchyLevel6({
  size = 24,
  className = '',
  ...props
}: LucideProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={className}
      {...props}
    >
      {/* Top-left chevron */}
      <path
        d="M5.5 7 L8 4 L10.5 7"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Top-right chevron */}
      <path
        d="M13.5 7 L16 4 L18.5 7"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Middle-left chevron */}
      <path
        d="M5.5 13.5 L8 10.5 L10.5 13.5"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Middle-right chevron */}
      <path
        d="M13.5 13.5 L16 10.5 L18.5 13.5"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Bottom-left chevron */}
      <path
        d="M5.5 20 L8 17 L10.5 20"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Bottom-right chevron */}
      <path
        d="M13.5 20 L16 17 L18.5 20"
        strokeWidth="2"
        stroke="currentColor"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
